import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL;

const createAuthHeaders = () => {
  const userToken = localStorage.getItem('userToken');
  if (!userToken) {
    console.log('Token de usuário não encontrado.');
    const error = new Error();
    const stackLines = error.stack.split('\n');
    const callerLine = stackLines[2];
    console.log('Função que chamou:', callerLine.trim());
    return false;
  }
  return {
    headers: {
      Authorization: `Bearer ${JSON.parse(userToken)}`,
    },
  };
};

export const validateUser = async () => {
  const user = JSON.parse(localStorage.getItem('userData'));
  // modo old
  const token = JSON.parse(localStorage.getItem('userToken'));

  try {
    const response = await axios.post(`${API_URL}/validateuser`, user, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (response.status !== 200) {
      return { ok: false, msg: response.msg };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return { ok: true, usuario: data.usuario };
  } catch (error) {
    // console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: error.response.data.msg };
    // throw error;
  }
};

// Modulos -------------------------------------------------
export const getModulos = async (filtro) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/modulos`, filtro, token);
    if (response.status !== 200) {
      return { ok: false, msg: 'Erro ao buscar dados da API' };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data.resultado;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: `Erro ao buscar dados da API` };
    // throw error;
  }
};

export const updateModulo = async (modulo) => {
  const token = createAuthHeaders();
  try {
    const user = JSON.parse(localStorage.getItem('userData'));
    const response = await axios.post(`${API_URL}/modulo`, { ...modulo, user }, token);
    if (response.status !== 200) {
      return { ok: false, msg: 'Erro ao buscar dados da API' };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return { ok: true, msg: data.msg };
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: `Erro ao buscar dados da API` };
    // throw error;
  }
};

export const getUnoKit = async (filtro) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/unokit`, filtro, token);
    if (response.status !== 200) {
      return { ok: false, msg: 'Erro ao buscar dados da API' };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data.resultado;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: `Erro ao buscar dados da API` };
    // throw error;
  }
};

export const getUnoModulo = async (filtro) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/unomodulo`, filtro, token);
    if (response.status !== 200) {
      return { ok: false, msg: 'Erro ao buscar dados da API' };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data.resultado;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: `Erro ao buscar dados da API` };
    // throw error;
  }
};

export const getUnoInversor = async (filtro) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/unoinversor`, filtro, token);
    if (response.status !== 200) {
      return { ok: false, msg: 'Erro ao buscar dados da API' };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data.resultado;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: `Erro ao buscar dados da API` };
    // throw error;
  }
};

// Inversores -------------------------------------------------
export const getUnoBateria = async (filtro) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/unobateria`, filtro, token);
    if (response.status !== 200) return { ok: false, msg: 'Erro ao buscar dados da API' };
    return response.data.resultado;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: 'Erro ao buscar dados da API' };
  }
};

export const getUnoInversorBombeamento = async (filtro) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/unoinversorbomb`, filtro, token);
    if (response.status !== 200) return { ok: false, msg: 'Erro ao buscar dados da API' };
    return response.data.resultado;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: 'Erro ao buscar dados da API' };
  }
};

export const getInversores = async (filtro) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/inversores`, filtro, token);
    if (response.status !== 200) {
      return { ok: false, msg: 'Erro ao buscar dados da API' };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data.resultado;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: `Erro ao buscar dados da API` };
    // throw error;
  }
};

export const updateInversor = async (dado) => {
  const token = createAuthHeaders();
  const user = JSON.parse(localStorage.getItem('userData'));
  try {
    const response = await axios.post(`${API_URL}/inversor`, { ...dado, user }, token);
    if (response.status !== 200) {
      return { ok: false, msg: 'Erro ao buscar dados da API' };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return { ok: true, msg: data.msg };
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: `Erro ao buscar dados da API` };
    // throw error;
  }
};


// Baterias -------------------------------------------------
export const getBaterias = async (filtro) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/baterias`, filtro, token);
    if (response.status !== 200) return { ok: false, msg: 'Erro ao buscar dados da API' };
    return response.data.resultado;
  } catch (error) {
    console.error('Erro ao buscar baterias:', error);
    return { ok: false, msg: 'Erro ao buscar dados da API' };
  }
};

export const updateBateria = async (dado) => {
  const token = createAuthHeaders();
  const user = JSON.parse(localStorage.getItem('userData'));
  try {
    const response = await axios.post(`${API_URL}/bateria`, { ...dado, user }, token);
    if (response.status !== 200) return { ok: false, msg: 'Erro ao buscar dados da API' };
    return { ok: true, msg: response.data.msg };
  } catch (error) {
    console.error('Erro ao atualizar bateria:', error);
    return { ok: false, msg: 'Erro ao buscar dados da API' };
  }
};

// Inversores Bombeamento -------------------------------------------------
export const getInversoresBomb = async (filtro) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/inversoresbomb`, filtro, token);
    if (response.status !== 200) return { ok: false, msg: 'Erro ao buscar dados da API' };
    return response.data.resultado;
  } catch (error) {
    console.error('Erro ao buscar inversores bombeamento:', error);
    return { ok: false, msg: 'Erro ao buscar dados da API' };
  }
};

export const updateInversorBomb = async (dado) => {
  const token = createAuthHeaders();
  const user = JSON.parse(localStorage.getItem('userData'));
  try {
    const response = await axios.post(`${API_URL}/inversorbomb`, { ...dado, user }, token);
    if (response.status !== 200) return { ok: false, msg: 'Erro ao buscar dados da API' };
    return { ok: true, msg: response.data.msg };
  } catch (error) {
    console.error('Erro ao atualizar inversor bombeamento:', error);
    return { ok: false, msg: 'Erro ao buscar dados da API' };
  }
};

export const getUnoInversorBomb = async (filtro) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/unoinversorbomb`, filtro, token);
    if (response.status !== 200) return { ok: false, msg: 'Erro ao buscar dados da API' };
    return response.data.resultado;
  } catch (error) {
    console.error('Erro ao buscar inversor bombeamento:', error);
    return { ok: false, msg: 'Erro ao buscar dados da API' };
  }
};

// HSP — busca por cidade + UF
export const getHsp = async (cidade, uf) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/hsp`, { cidade, uf }, token);
    if (response.status !== 200) return null;
    return response.data.resultado;
  } catch (error) {
    console.error('Erro ao buscar HSP:', error);
    return null;
  }
};

// HSP — busca por código IBGE (mais precisa, evita homônimos)
export const getHspIbge = async (ibge) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/hsp/ibge`, { ibge }, token);
    if (response.status !== 200) return null;
    return response.data.resultado;
  } catch (error) {
    console.error('Erro ao buscar HSP por IBGE:', error);
    return null;
  }
};

// Estados/Municípios — cache local do IBGE (evita fetch direto ao IBGE no navegador)
export const getEstados = async () => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/estados`, {}, token);
    if (response.status !== 200) return [];
    return response.data.resultado;
  } catch (error) {
    console.error('Erro ao buscar estados:', error);
    return [];
  }
};

export const getMunicipios = async (sigla) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/estados/municipios`, { sigla }, token);
    if (response.status !== 200) return [];
    return response.data.resultado;
  } catch (error) {
    console.error('Erro ao buscar municípios:', error);
    return [];
  }
};

// Empresa — identidade visual (logos) usada nos PDFs de propostas e relatórios
export const getEmpresaAtual = async (unidadeId) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/empresa/atual`, { unidadeId }, token);
    if (response.status !== 200) return null;
    return response.data.resultado;
  } catch (error) {
    console.error('Erro ao buscar empresa:', error);
    return null;
  }
};

export const updateEmpresaLogo = async (id, campos) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/empresa/atualizar`, { id, ...campos }, token);
    if (response.status !== 200) return { ok: false, msg: response.data?.msg };
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar empresa:', error);
    return { ok: false, msg: error.response?.data?.msg || 'Erro ao atualizar empresa' };
  }
};

// Alias semântico do mesmo endpoint acima (/empresa/atualizar aceita
// qualquer campo via strict:false no backend) — usado pelas abas de
// Cadastro e Identidade Visual/Paleta da tela de Configuração de Empresa,
// para não misturar com a função de logo por nome.
export const updateEmpresaDados = async (id, campos) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/empresa/atualizar`, { id, ...campos }, token);
    if (response.status !== 200) return { ok: false, msg: response.data?.msg };
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar dados da empresa:', error);
    return { ok: false, msg: error.response?.data?.msg || 'Erro ao atualizar dados da empresa' };
  }
};

// Unidades — CRUD simples, vinculadas a uma Empresa
export const getUnidades = async (empresaId, opcoes = {}) => {
  const token = createAuthHeaders();
  const { incluirInativas = false } = opcoes;
  try {
    const response = await axios.post(`${API_URL}/unidades/listar`, { empresaId, incluirInativas }, token);
    if (response.status !== 200) return [];
    return response.data.resultado;
  } catch (error) {
    console.error('Erro ao listar unidades:', error);
    return [];
  }
};

export const addUnidade = async (nome, empresaId, endereco) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/unidades/criar`, { nome, empresaId, endereco }, token);
    if (response.status !== 200) return { ok: false, msg: response.data?.msg };
    return response.data;
  } catch (error) {
    console.error('Erro ao criar unidade:', error);
    return { ok: false, msg: error.response?.data?.msg || 'Erro ao criar unidade' };
  }
};

export const updateUnidade = async (id, nome, endereco) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/unidades/atualizar`, { id, nome, endereco }, token);
    if (response.status !== 200) return { ok: false, msg: response.data?.msg };
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar unidade:', error);
    return { ok: false, msg: error.response?.data?.msg || 'Erro ao atualizar unidade' };
  }
};

export const deleteUnidade = async (id) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/unidades/excluir`, { id }, token);
    return response.data;
  } catch (error) {
    console.error('Erro ao excluir unidade:', error);
    return { ok: false, msg: error.response?.data?.msg || 'Erro ao excluir unidade' };
  }
};

// Inativação (soft delete) — usada quando deleteUnidade é bloqueado por
// vínculo (usuário ou proposta), ou diretamente pelo botão de inativar.
export const inativarUnidade = async (id) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/unidades/inativar`, { id }, token);
    if (response.status !== 200) return { ok: false, msg: response.data?.msg };
    return response.data;
  } catch (error) {
    console.error('Erro ao inativar unidade:', error);
    return { ok: false, msg: error.response?.data?.msg || 'Erro ao inativar unidade' };
  }
};

export const reativarUnidade = async (id) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/unidades/reativar`, { id }, token);
    if (response.status !== 200) return { ok: false, msg: response.data?.msg };
    return response.data;
  } catch (error) {
    console.error('Erro ao reativar unidade:', error);
    return { ok: false, msg: error.response?.data?.msg || 'Erro ao reativar unidade' };
  }
};

// Kit -------------------------------------------------
export const getKits = async (filtro) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/kits`, filtro, token);
    if (response.status !== 200) {
      return { ok: false, msg: 'Erro ao buscar dados da API' };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data.resultado;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: `Erro ao buscar dados da API` };
    // throw error;
  }
};

// Consulta isolada para o seletor do estoque; falhas não viram catálogo vazio.
export const getCatalogoKitsEstoque = async () => {
  const token = createAuthHeaders();
  const responses = await Promise.all([
    axios.post(`${API_URL}/kits`, {}, token),
    axios.post(`${API_URL}/kits`, { tipokat: 'bombeamento' }, token),
    axios.post(`${API_URL}/kitsoffgrid`, {}, token),
  ]);
  return responses.map((response, index) => {
    if (response.status !== 200 || !Array.isArray(response.data?.resultado)) {
      throw new Error('Não foi possível consultar o catálogo de kits');
    }
    return { categoria: ['On-grid', 'Bombeamento', 'Off-grid'][index], kits: response.data.resultado };
  });
};

export const updateKit = async (dado) => {
  const token = createAuthHeaders();
  const user = JSON.parse(localStorage.getItem('userData'));
  try {
    const response = await axios.post(`${API_URL}/kit`, { ...dado, user }, token);
    if (response.status !== 200) {
      return { ok: false, msg: 'Erro ao buscar dados da API' };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return { ok: true, msg: data.msg };
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: `Erro ao buscar dados da API` };
    // throw error;
  }
};

// TipoDisjuntores -------------------------------------------------
export const getTipoDisjuntores = async () => {
  const token = createAuthHeaders();
  try {
    const response = await fetch(`${API_URL}/tipodisjuntores`, token);
    if (!response.ok) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = await response.json();
    return data.resultado;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

// PotenciaDisjuntor -------------------------------------------------
export const getPotenciaDisjuntores = async () => {
  const token = createAuthHeaders();
  try {
    const response = await fetch(`${API_URL}/potenciadisjuntores`, token);
    if (!response.ok) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = await response.json();
    return data.resultado;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

export const getPropostas = async (filtro) => {
  const token = createAuthHeaders();
  if (filtro) {
    try {
      const response = await axios.post(`${API_URL}/propostas`, filtro, token);
      if (response.status !== 200) {
        return { ok: false, msg: response.msg };
        // throw new Error('Erro ao buscar dados da API');
      }
      const data = response.data.resultado;
      return data;
    } catch (error) {
      // console.error('Erro ao buscar dados da API:', error);
      return { ok: false, msg: error.response.data.msg };
      // throw error;
    }
  }
  return [];
};

export const updateProposta = async (proposta, anexos) => {
  const token = createAuthHeaders();
  const user = JSON.parse(localStorage.getItem('userData'));
  try {
    const response = await axios.post(`${API_URL}/proposta`, { proposta, userLogado: user, anexos }, token);
    if (response.status !== 200) {
      console.log(response);
      return { ok: false, msg: 'Erro ao buscar dados da API' };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return { ok: true, msg: data.msg, data: data.resultado };
  } catch (error) {
    console.log(error);
    console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: `Erro ao buscar dados da API` };
    // throw error;
  }
};

export const getUnoProposta = async (filtro) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/unoproposta`, filtro, token);
    if (response.status !== 200) {
      return { ok: false, msg: 'Erro ao buscar dados da API' };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data.resultado;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: `Erro ao buscar dados da API` };
    // throw error;
  }
};

export const getLightPropostas = async (filtro) => {
  const token = createAuthHeaders();
  if (filtro) {
    try {
      const response = await axios.post(`${API_URL}/lightpropostas`, filtro, token);
      if (response.status !== 200) {
        return { ok: false, msg: response.msg };
        // throw new Error('Erro ao buscar dados da API');
      }
      const data = response.data.resultado;
      return data;
    } catch (error) {
      // console.error('Erro ao buscar dados da API:', error);
      return { ok: false, msg: error.response.data.msg };
      // throw error;
    }
  }
  return [];
};

export const getLightPropostasVendas = async (filtro) => {
  const token = createAuthHeaders();
  if (filtro) {
    try {
      const response = await axios.post(`${API_URL}/lightpropostasvendas`, filtro, token);
      if (response.status !== 200) {
        return { ok: false, msg: response.msg };
        // throw new Error('Erro ao buscar dados da API');
      }
      const data = response.data.resultado;
      return data;
    } catch (error) {
      // console.error('Erro ao buscar dados da API:', error);
      return { ok: false, msg: error.response.data.msg };
      // throw error;
    }
  }
  return [];
};

export const deleteProposta = async (proposta) => {
  const token = createAuthHeaders();
  const user = JSON.parse(localStorage.getItem('userData'));
  if (proposta) {
    try {
      const response = await axios.post(`${API_URL}/deleteproposta`, { proposta, user }, token);
      if (response.status !== 200) {
        return { ok: false, msg: response.msg };
        // throw new Error('Erro ao buscar dados da API');
      }
      const data = response.data.resultado;
      return data;
    } catch (error) {
      // console.error('Erro ao buscar dados da API:', error);
      return { ok: false, msg: error.response.data.msg };
      // throw error;
    }
  }
  return false;
};

// Produto -------------------------------------------------
export const getProdutos = async () => {
  const token = createAuthHeaders();
  try {
    const response = await fetch(`${API_URL}/produtos`, token);
    if (!response.ok) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = await response.json();
    return data.resultado;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

// Fornecedores -------------------------------------------------
export const getFornecedores = async () => {
  const token = createAuthHeaders();
  try {
    const response = await fetch(`${API_URL}/fornecedores`, token);
    if (!response.ok) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = await response.json();
    return data.resultado;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

// Distribuidora -------------------------------------------------
export const getDistribuidoras = async () => {
  const token = createAuthHeaders();
  try {
    const response = await fetch(`${API_URL}/fornecedores`, token);
    if (!response.ok) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = await response.json();
    return data.resultado;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

export const insertFornecedor = async (dado) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/fornecedor`, dado, token);
    if (response.status !== 200) {
      return { ok: false, msg: response.msg };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return { ok: true, msg: data.msg };
  } catch (error) {
    // console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: error.response.data.msg };
    // throw error;
  }
};

// Cliente -------------------------------------------------
export const getClientes = async (filtro) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/clientes`, filtro, token);
    if (response.status !== 200) {
      return { ok: false, msg: 'Erro ao buscar dados da API' };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data.resultado;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: `Erro ao buscar dados da API` };
    // throw error;
  }
};
// Cliente -------------------------------------------------
export const getClientesPagina = async (filtro) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/clientespagina`, filtro, token);

    if (response.status !== 200) {
      return { ok: false, msg: 'Erro ao buscar dados da API' };
      // throw new Error('Erro ao buscar dados da API');
    }
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: `Erro ao buscar dados da API` };
    // throw error;
  }
};

export const updateCliente = async (dado) => {
  const token = createAuthHeaders();
  const user = JSON.parse(localStorage.getItem('userData'));
  try {
    const response = await axios.post(`${API_URL}/cliente`, { ...dado, user }, token);
    if (response.status !== 200) {
      return { ok: false, msg: response.msg };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return { ok: true, msg: data.msg, _id: data._id, data };
  } catch (error) {
    // console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: error.response.data.msg };
    // throw error;
  }
};

// Indicador
export const getIndicadores = async (filtro) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/indicadores`, filtro, token);
    if (response.status !== 200) {
      return { ok: false, msg: 'Erro ao buscar dados da API' };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data.resultado;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: `Erro ao buscar dados da API` };
    // throw error;
  }
};

export const updateIndicador = async (dado) => {
  const token = createAuthHeaders();
  const user = JSON.parse(localStorage.getItem('userData'));
  try {
    const response = await axios.post(`${API_URL}/indicador`, { ...dado, user }, token);
    if (response.status !== 200) {
      return { ok: false, msg: response.msg };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return { ok: true, msg: data.msg, _id: data._id };
  } catch (error) {
    // console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: error.response.data.msg };
    // throw error;
  }
};

// Fluxograma -------------------------------------------------
export const getFluxogramas = async () => {
  const token = createAuthHeaders();
  try {
    const response = await fetch(`${API_URL}/fluxogramas`, token);
    if (!response.ok) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = await response.json();
    return data.resultado;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

// OrientacaoTelhado -------------------------------------------------
export const getOrientacaoTelhados = async () => {
  const token = createAuthHeaders();
  try {
    const response = await fetch(`${API_URL}/orientacaotelhados`, token);
    if (!response.ok) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = await response.json();
    return data.resultado;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

// Anexo -------------------------------------------------
export const getAnexos = async (parametro) => {
  const token = createAuthHeaders();
  try {
    // const response = await fetch(`${API_URL}/anexos`);
    const response = await axios.post(`${API_URL}/anexos`, parametro, token);
    if (response.status !== 200) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

export const getUnoAnexo = async (parametro) => {
  const token = createAuthHeaders();
  try {
    // const response = await fetch(`${API_URL}/anexos`);
    const response = await axios.post(`${API_URL}/getunoanexo`, parametro, token);
    if (response.status !== 200) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

export const deleteUnoAnexo = async (parametro) => {
  const token = createAuthHeaders();
  try {
    // const response = await fetch(`${API_URL}/anexos`);
    const response = await axios.post(`${API_URL}/deleteunoanexo`, parametro, token);
    if (response.status !== 200) {
      // throw new Error('Erro ao buscar dados da API');
      return false;
    }
    const data = response.data;
    return data;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    return false;
    // throw error;
  }
};

// Usuarios -------------------------------------------------
export const getUsuarios = async () => {
  const token = createAuthHeaders();
  try {
    const response = await axios.get(`${API_URL}/usuarios`, token);
    if (response.status !== 200) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data.resultado;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

// Usuarios -------------------------------------------------
export const getUsuariosInativos = async () => {
  const token = createAuthHeaders();
  try {
    const response = await axios.get(`${API_URL}/usuariosinativos`, token);
    if (response.status !== 200) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data.resultado;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

// Usuarios Montador -------------------------------------------------
export const getUsuariosMontador = async () => {
  const token = createAuthHeaders();
  try {
    const response = await axios.get(`${API_URL}/usuariosmontador`, token);
    if (response.status !== 200) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data.resultado;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

export const updateUsuario = async (dado) => {
  const token = createAuthHeaders();
  const user = JSON.parse(localStorage.getItem('userData'));
  try {
    const response = await axios.post(`${API_URL}/usuario`, { ...dado, user }, token);
    if (response.status !== 200) {
      return { ok: false, msg: response.msg };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return { ok: true, msg: data.msg };
  } catch (error) {
    // console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: error.response.data.msg };
    // throw error;
  }
};

export const updateMensagem = async (fluxo, etapa) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/mensagem`, { fluxo, etapa }, token);
    if (response.status !== 200) {
      return { ok: false, msg: response.msg };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return { ok: true, msg: data.msg };
  } catch (error) {
    // console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: error.response.data.msg };
    // throw error;
  }
};

// Home Dados
export const GetDadosHome = async (filtro) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/dadoshome`, filtro, token);
    if (response.status !== 200) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data.resultado;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

// Home Dados Leads
export const GetDadosHomeLeads = async (filtro) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/dadoshomeleads`, filtro, token);
    if (response.status !== 200) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data.resultado;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

// Home Dados Engenharia
export const GetDadosHomeEngenharia = async (filtro) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/dadoshomeengenharia`, filtro, token);
    if (response.status !== 200) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data.resultado;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

// Home Dados Montagem
export const GetDadosHomeMontagem = async (filtro) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/dadoshomemontagem`, filtro, token);
    if (response.status !== 200) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data.resultado;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

// Metas
export const getMetas = async (filtro) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/metas`, filtro, token);
    if (response.status !== 200) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data.resultado;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

export const updateMeta = async (dado) => {
  const token = createAuthHeaders();
  const user = JSON.parse(localStorage.getItem('userData'));
  try {
    const response = await axios.post(`${API_URL}/meta`, { ...dado, user }, token);
    if (response.status !== 200) {
      return { ok: false, msg: response.msg };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return { ok: true, msg: data.msg };
  } catch (error) {
    // console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: error.response.data.msg };
    // throw error;
  }
};

// Logs
export const getLogs = async (filtro) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/logs`, filtro, token);
    if (response.status !== 200) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;

    return data.resultado;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

// Formas de Pagamento
export const getFormasPagamento = async () => {
  const token = createAuthHeaders();
  try {
    const response = await axios.get(`${API_URL}/formaspagamento`, token);
    if (response.status !== 200) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

export const getFormasRecebimento = async () => {
  const token = createAuthHeaders();
  try {
    const response = await axios.get(`${API_URL}/formasrecebimento`, token);
    if (response.status !== 200) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

export const getContasBancario = async () => {
  const token = createAuthHeaders();
  try {
    const response = await axios.get(`${API_URL}/contasbancario`, token);
    if (response.status !== 200) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

export const getOperadoras = async () => {
  const token = createAuthHeaders();
  try {
    const response = await axios.get(`${API_URL}/operadoras`, token);
    if (response.status !== 200) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

export const getBandeiras = async () => {
  const token = createAuthHeaders();
  try {
    const response = await axios.get(`${API_URL}/bandeiras`, token);
    if (response.status !== 200) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

export const getBancos = async () => {
  const token = createAuthHeaders();
  try {
    const response = await axios.get(`${API_URL}/bancos`, token);
    if (response.status !== 200) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

// Tipo Anexo
export const getTipoAnexo = async () => {
  const token = createAuthHeaders();
  try {
    const response = await axios.get(`${API_URL}/tipoanexo`, token);
    if (response.status !== 200) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

// Superficies
export const getSuperficie = async () => {
  const token = createAuthHeaders();
  try {
    const response = await axios.get(`${API_URL}/superficie`, token);
    if (response.status !== 200) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

// Indices --------------------------------

export const getIndices = async () => {
  const token = createAuthHeaders();
  try {
    const response = await axios.get(`${API_URL}/indices`, token);
    if (response.status !== 200) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

export const getIndiceById = async (id) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.get(`${API_URL}/indices/${id}`, token);
    if (response.status !== 200) {
      throw new Error('Erro ao buscar dados da API');
    }
    return response.data; // Retorna o objeto do índice
  } catch (error) {
    console.error(`Erro ao buscar índice com ID ${id}:`, error);
    throw error;
  }
};

export const updateIndices = async (indice) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/indices`, indice, token);
    if (response.status !== 200) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data.resultado;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

// Chamado --------------------------------

export const getChamados = async (filtro) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/chamados`, filtro, token);
    if (response.status !== 200) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

export const updateChamado = async (chamado) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/chamado`, chamado, token);
    if (response.status !== 200) {
      throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    console.error('Erro ao buscar dados da API:', error);
    throw error;
  }
};

// Vendas ------

export const getOss = async (filtro) => {
  const token = createAuthHeaders();

  try {
    const response = await axios.post(`${API_URL}/api/oslist`, filtro, token);
    if (response.status !== 200) {
      return { ok: false, msg: response.msg };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    // console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: error.response.data.msg };
    // throw error;
  }
};

export const getOssDashboard = async (filtro) => {
  const token = createAuthHeaders();

  try {
    const response = await axios.post(`${API_URL}/api/os/dashboard`, filtro, token);
    if (response.status !== 200) {
      return { ok: false, msg: response.msg };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    // console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: error.response.data.msg };
    // throw error;
  }
};

export const getAgendamentosDia = async (filtro) => {
  const token = createAuthHeaders();

  try {
    const response = await axios.post(`${API_URL}/api/os/agendamentos-dia`, filtro, token);
    if (response.status !== 200) {
      return { ok: false, msg: response.msg };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    // console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: error.response.data.msg };
    // throw error;
  }
};

// Vendas ------

export const getVendas = async (filtro) => {
  const token = createAuthHeaders();

  try {
    const response = await axios.post(`${API_URL}/api/vendas`, filtro, token);
    if (response.status !== 200) {
      return { ok: false, msg: response.msg };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    // console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: error.response.data.msg };
    // throw error;
  }
};

// Vendas ------

export const getKitEstoques = async (filtro) => {
  const token = createAuthHeaders();

  try {
    const response = await axios.post(`${API_URL}/api/kitscomestoque`, filtro, token);
    if (response.status !== 200) {
      return { ok: false, msg: response.msg };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    // console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: error.response.data.msg };
    // throw error;
  }
};

export const updateVenda = async (venda) => {
  const token = createAuthHeaders();
  const user = JSON.parse(localStorage.getItem('userData'));
  try {
    const response = await axios.post(`${API_URL}/api/venda`, { ...venda, user }, token);
    if (response.status !== 200) {
      return { ok: false, msg: response.msg };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    // console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: error.response.data.msg };
    // throw error;
  }
};

export const deleteVenda = async (venda, motivoCancelamento) => {
  const token = createAuthHeaders();
  const user = JSON.parse(localStorage.getItem('userData'));
  if (venda) {
    try {
      const response = await axios.post(`${API_URL}/api/deletevenda`, { venda, motivoCancelamento, user }, token);
      if (response.status !== 200) {
        return { ok: false, msg: response.msg };
        // throw new Error('Erro ao buscar dados da API');
      }
      const data = response.data;
      return data;
    } catch (error) {
      // console.error('Erro ao buscar dados da API:', error);
      return { ok: false, msg: error.response.data.msg };
      // throw error;
    }
  }
  return false;
};

export const getFinanceiroLogs = async (filtro = {}) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/api/financeiro-logs`, filtro, token);
    if (response.status !== 200) {
      return { ok: false, msg: response.data?.message || 'Erro ao buscar log financeiro' };
    }
    return response.data;
  } catch (error) {
    return {
      ok: false,
      msg: error.response?.data?.message || 'Erro ao buscar log financeiro',
    };
  }
};

export const deleteOs = async (os) => {
  const token = createAuthHeaders();
  const user = JSON.parse(localStorage.getItem('userData'));
  if (os) {
    try {
      const response = await axios.post(`${API_URL}/api/deleteos`, { os, user }, token);
      if (response.status !== 200) {
        return { ok: false, msg: response.msg };
        // throw new Error('Erro ao buscar dados da API');
      }
      const data = response.data;
      return data;
    } catch (error) {
      // console.error('Erro ao buscar dados da API:', error);
      return { ok: false, msg: error.response.data.msg };
      // throw error;
    }
  }
  return false;
};

// Receitas
export const getReceitas = async (filtro) => {
  const token = createAuthHeaders();

  try {
    const response = await axios.post(`${API_URL}/api/receitas`, filtro, token);
    if (response.status !== 200) {
      return { ok: false, msg: response.msg };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    // console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: error.response.data.msg };
    // throw error;
  }
};

export const updateReceita = async (dados) => {
  const token = createAuthHeaders();
  const user = JSON.parse(localStorage.getItem('userData'));
  try {
    const response = await axios.post(`${API_URL}/api/receita`, { ...dados, user }, token);
    if (response.status !== 200) {
      return { ok: false, msg: response.msg };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    // console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: error.response.data.msg };
    // throw error;
  }
};

export const deleteReceita = async (receita, motivoCancelamento) => {
  const token = createAuthHeaders();
  const user = JSON.parse(localStorage.getItem('userData'));
  if (receita) {
    try {
      const response = await axios.post(`${API_URL}/api/deletereceita`, { receita, motivoCancelamento, user }, token);
      if (response.status !== 200) {
        return { ok: false, msg: response.msg };
        // throw new Error('Erro ao buscar dados da API');
      }
      const data = response.data;
      return data;
    } catch (error) {
      // console.error('Erro ao buscar dados da API:', error);
      return { ok: false, msg: error.response.data.msg };
      // throw error;
    }
  }
  return false;
};

// Centro Custo
export const getGenericData = async (colecao, filtro) => {
  const token = createAuthHeaders();

  try {
    const response = await axios.post(`${API_URL}/api/${colecao}s`, filtro, token);
    if (response.status !== 200) {
      return { ok: false, msg: response.msg };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    // console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: error.response.data.msg };
    // throw error;
  }
};

export const updateGenericData = async (colecao, dados) => {
  const token = createAuthHeaders();
  const user = JSON.parse(localStorage.getItem('userData'));
  try {
    const response = await axios.post(`${API_URL}/api/${colecao}`, { ...dados, user }, token);
    if (response.status !== 200) {
      return { ok: false, msg: response.msg };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    // console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: error.response.data.msg };
    // throw error;
  }
};

export const deleteGenericData = async (colecao, dados) => {
  const token = createAuthHeaders();
  const user = JSON.parse(localStorage.getItem('userData'));
  if (dados) {
    try {
      const response = await axios.post(`${API_URL}/api/delete${colecao}`, { ...dados, user }, token);
      if (response.status !== 200) {
        return { ok: false, msg: response.msg };
        // throw new Error('Erro ao buscar dados da API');
      }
      const data = response.data;
      return data;
    } catch (error) {
      // console.error('Erro ao buscar dados da API:', error);
      return { ok: false, msg: error.response.data.msg };
      // throw error;
    }
  }
  return false;
};


export const acaoGrupoReceitas = async (dados) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/api/acao-grupo-receitas`, dados, token);
    return response.data;
  } catch (error) {
    return {
      ok: false,
      success: false,
      msg: error.response?.data?.message || 'Erro ao processar parcelas futuras de receita',
      message: error.response?.data?.message || 'Erro ao processar parcelas futuras de receita',
    };
  }
};

export const acaoGrupoDespesas = async (dados) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/api/acao-grupo-despesas`, dados, token);
    return response.data;
  } catch (error) {
    return {
      ok: false,
      success: false,
      msg: error.response?.data?.message || 'Erro ao processar despesas futuras',
      message: error.response?.data?.message || 'Erro ao processar despesas futuras',
    };
  }
};


export const estornarReceita = async (receitaId, motivo) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/api/estornar-receita`, { receitaId, motivo }, token);
    return response.data;
  } catch (error) {
    return {
      success: false,
      ok: false,
      message: error.response?.data?.message || 'Erro ao estornar o recebimento',
    };
  }
};

export const estornarDespesa = async (despesaId, motivo) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/api/estornar-despesa`, { despesaId, motivo }, token);
    return response.data;
  } catch (error) {
    return {
      success: false,
      ok: false,
      message: error.response?.data?.message || 'Erro ao estornar o pagamento',
    };
  }
};

const abrirBlobPdf = (blob, nome, baixar = false) => {
  const url = window.URL.createObjectURL(blob);
  if (baixar) {
    const link = document.createElement('a');
    link.href = url;
    link.download = nome || 'comprovante.pdf';
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => window.URL.revokeObjectURL(url), 1000);
    return;
  }

  window.open(url, '_blank', 'noopener,noreferrer');
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
};

export const abrirComprovanteFinanceiro = async (id, nome, baixar = false) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.get(`${API_URL}/api/comprovante-financeiro/${id}`, {
      ...token,
      responseType: 'blob',
    });
    abrirBlobPdf(response.data, nome, baixar);
    return { success: true };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || 'Erro ao abrir o comprovante',
    };
  }
};

// dashboard vendas

// Receitas
export const getResumoFinanceiro = async (filtro) => {
  const token = createAuthHeaders();

  try {
    const response = await axios.post(`${API_URL}/resumo-financeiro`, filtro, token);
    if (response.status !== 200) {
      return { ok: false, msg: response.msg };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    // console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: error.response.data.msg };
    // throw error;
  }
};

// Despesas
export const getResumoDespesas = async (filtro) => {
  const token = createAuthHeaders();

  try {
    const response = await axios.post(`${API_URL}/resumo-despesas`, filtro, token);
    if (response.status !== 200) {
      return { ok: false, msg: response.msg };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    // console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: error.response.data.msg };
    // throw error;
  }
};

// Contas Saldo
export const getResumoContas = async (filtro) => {
  const token = createAuthHeaders();

  try {
    const response = await axios.post(`${API_URL}/resumo-contas`, filtro, token);
    if (response.status !== 200) {
      return { ok: false, msg: response.msg };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    // console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: error.response.data.msg };
    // throw error;
  }
};

// Contas Saldo
export const getDatasEmAberto = async (filtro) => {
  const token = createAuthHeaders();

  try {
    const response = await axios.post(`${API_URL}/datasemaberto`, filtro, token);
    if (response.status !== 200) {
      return { ok: false, msg: response.msg };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    // console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: error.response.data.msg };
    // throw error;
  }
};

// Contas Saldo
export const getKpiVendas = async (filtro) => {
  const token = createAuthHeaders();

  try {
    const response = await axios.post(`${API_URL}/kpivendas`, filtro, token);
    if (response.status !== 200) {
      return { ok: false, msg: response.msg };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    // console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: error.response.data.msg };
    // throw error;
  }
};

// Contas Saldo
export const getCampeaoVendas = async (filtro) => {
  const token = createAuthHeaders();

  try {
    const response = await axios.post(`${API_URL}/campeaovendas`, filtro, token);
    if (response.status !== 200) {
      return { ok: false, msg: response.msg };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    // console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: error.response.data.msg };
    // throw error;
  }
};

// Totais Despesas
export const getTotaisDespesas = async (filtro) => {
  const token = createAuthHeaders();

  try {
    const response = await axios.post(`${API_URL}/totaisdespesas`, filtro, token);
    if (response.status !== 200) {
      return { ok: false, msg: response.msg };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    // console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: error.response.data.msg };
    // throw error;
  }
};

// Totais Receitas
export const getTotaisReceitas = async (filtro) => {
  const token = createAuthHeaders();

  try {
    const response = await axios.post(`${API_URL}/totaisreceitas`, filtro, token);
    if (response.status !== 200) {
      return { ok: false, msg: response.msg };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    // console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: error.response.data.msg };
    // throw error;
  }
};

// Totais Receitas
export const getGraficosReceitas = async (filtro) => {
  const token = createAuthHeaders();

  try {
    const response = await axios.post(`${API_URL}/graficosreceitas`, filtro, token);
    if (response.status !== 200) {
      return { ok: false, msg: response.msg };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    // console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: error.response.data.msg };
    // throw error;
  }
};

// Graficos Despesas
export const getGraficosDespesas = async (filtro) => {
  const token = createAuthHeaders();

  try {
    const response = await axios.post(`${API_URL}/graficosdespesas`, filtro, token);
    if (response.status !== 200) {
      return { ok: false, msg: response.msg };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    // console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: error.response.data.msg };
    // throw error;
  }
};

// Graficos Despesas
export const getAnyRoute = async (route, filtro) => {
  const token = createAuthHeaders();

  try {
    const response = await axios.post(`${API_URL}/${route}`, filtro, token);
    if (response.status !== 200) {
      return { ok: false, msg: response.msg };
      // throw new Error('Erro ao buscar dados da API');
    }
    const data = response.data;
    return data;
  } catch (error) {
    // console.error('Erro ao buscar dados da API:', error);
    return { ok: false, msg: error.response.data.msg };
    // throw error;
  }
};

export const createOs = async (os) => {
  const token = createAuthHeaders();
  const user = JSON.parse(localStorage.getItem('userData'));
  try {
    const response = await axios.post(`${API_URL}/api/os`, { ...os, user }, token);
    return response.data;
  } catch (error) {
    console.error('Erro ao criar/atualizar OS:', error);
    const errorMsg = error.response?.data?.message || error.message || 'Erro desconhecido ao salvar OS.';
    return { success: false, message: errorMsg };
  }
};

/**
 * @description Busca a lista de anexos (meta-dados) de uma OS.
 */
export const getAnexosByOsId = async (osId) => {
  try {
    const { data } = await axios.get(`${API_URL}/api/os/anexos/${osId}`);
    return data;
  } catch (error) {
    console.error('Erro ao buscar anexos:', error);
    throw error;
  }
};

/**
 * @description Baixa o conteúdo de um anexo específico.
 */
export const downloadAnexo = async (anexoId, filename) => {
  try {
    const response = await axios.get(`${API_URL}/api/anexo/download/${anexoId}`, {
      responseType: 'blob', // Muito importante: espera um blob (arquivo)
    });

    // Cria um link temporário para o blob
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename); // Define o nome do arquivo
    document.body.appendChild(link);
    link.click();

    // Limpa o link
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Erro ao baixar anexo:', error);
    throw error;
  }
};

// ── Equipamentos Off-Grid (biblioteca INMETRO/Procel) ────────────────────────

export const getEquipamentosOffGrid = async () => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/equipamentosoffgrid`, {}, token);
    if (response.status !== 200) return [];
    return response.data.resultado;
  } catch (error) {
    console.error('Erro ao buscar equipamentos off-grid:', error);
    return [];
  }
};

export const updateEquipamentoOffGrid = async (dado) => {
  const token = createAuthHeaders();
  const user  = JSON.parse(localStorage.getItem('userData'));
  try {
    const response = await axios.post(`${API_URL}/equipamentooffgrid`, { ...dado, user }, token);
    if (response.status !== 200) return { ok: false, msg: 'Erro ao salvar equipamento' };
    return { ok: true, msg: response.data.msg };
  } catch (error) {
    console.error('Erro ao salvar equipamento off-grid:', error);
    return { ok: false, msg: 'Erro ao salvar equipamento' };
  }
};


// ── Kits Off-Grid ────────────────────────────────────────────────────────────

export const getKitsOffGrid = async (filtro = {}) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/kitsoffgrid`, filtro, token);
    if (response.status !== 200) return [];
    return response.data.resultado;
  } catch (error) {
    console.error('Erro ao buscar kits off-grid:', error);
    return [];
  }
};

export const getUnoKitOffGrid = async (filtro) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(`${API_URL}/unokitoffgrid`, filtro, token);
    if (response.status !== 200) return null;
    return response.data.resultado;
  } catch (error) {
    console.error('Erro ao buscar kit off-grid:', error);
    return null;
  }
};

export const updateKitOffGrid = async (dado) => {
  const token = createAuthHeaders();
  const user  = JSON.parse(localStorage.getItem('userData'));
  try {
    const response = await axios.post(`${API_URL}/kitoffgrid`, { ...dado, user }, token);
    if (response.status !== 200) return { ok: false, msg: 'Erro ao salvar kit off-grid' };
    return { ok: true, msg: response.data.msg };
  } catch (error) {
    console.error('Erro ao salvar kit off-grid:', error);
    return { ok: false, msg: 'Erro ao salvar kit off-grid' };
  }
};

/**
 * Sugere o kit off-grid ideal para o dimensionamento calculado.
 * @param {number} potenciaCCNecessaria  kWp calculado
 * @param {number} autonomiaNecessaria   kWh de autonomia necessária
 * @param {number} [dod=0.9]             Depth of Discharge
 * @param {number} [rte=0.9]             RoundTrip Efficiency
 * @returns {{ resultado: object, parcial: boolean } | null}
 */
export const sugerirKitOffGrid = async (potenciaCCNecessaria, autonomiaNecessaria, dod = 0.9, rte = 0.9) => {
  const token = createAuthHeaders();
  try {
    const response = await axios.post(
      `${API_URL}/kitsoffgrid/sugerir`,
      { potenciaCCNecessaria, autonomiaNecessaria, dod, rte },
      token
    );
    if (response.status !== 200) return null;
    return response.data; // { resultado, parcial }
  } catch (error) {
    console.error('Erro ao sugerir kit off-grid:', error);
    return null;
  }
};
